import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AppService } from './app.service';

@Injectable()
export class BaseService {

  constructor(public http: HttpClient, public appService: AppService) { }


  private headerOptions() {

    const token = sessionStorage.getItem('lyt-auth-token');

    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      Authorization: token != null ? token : ''
    });
  }

  private formHeaderOptions() {

    const token = sessionStorage.getItem('lyt-auth-token');

    return new HttpHeaders({
      Authorization: token != null ? token : '',
    });
  }

  //-- HTTP - GET METHOD -----------------------------------------------|

  get(url: string) {

    const requestOptions = { headers: this.headerOptions() }

    return this.http
      .get(url, requestOptions)
      .pipe(map(this.handleSuccessResponse), catchError(this.handleErrorResponse));
  }

  //-- HTTP - POST METHOD ----------------------------------------------|

  post(url: string, postBody: any) {

    const requestOptions = { headers: this.formHeaderOptions() }

    return this.http
      .post(url, postBody, requestOptions)
      .pipe(map(this.handleSuccessResponse), catchError(this.handleErrorResponse));
  }

  //-- HTTP - PATCH METHOD ---------------------------------------------|

  patch(url: string, postBody: any) {

    const requestOptions = { headers: this.formHeaderOptions() }

    return this.http
      .patch(url, postBody, requestOptions)
      .pipe(map(this.handleSuccessResponse), catchError(this.handleErrorResponse));
  }

  //-- HTTP - SUCCESS RESPONSE -----------------------------------------|

  handleSuccessResponse(res: any) {

    if (res != undefined) {
      return res;
    }
    else {
      return throwError(() => '');
    }
  }

  //-- HTTP - ERROR RESPONSE -------------------------------------------|

  handleErrorResponse(res: any) {

    if (res?.error != undefined) {
      const response = res.error;
      return throwError(() => response);
    }
    else {
      return throwError(() => '');
    }
  }

  //--------------------------------------------------------------------|

}

